<h2 mat-dialog-title>{{ configuration.title }}</h2>
<div mat-dialog-content class="modal-custom-content">
    <ng-template #container></ng-template>
</div>
